import { Injectable } from '@angular/core';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const EXCEL_EXTENSION = '.csv';

@Injectable({
  providedIn: 'root',
})
export class ExcelService {
  public exportAsExcelFileWithHeader(headings: any[], fileName: string) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('My Sheet');
    const columns = this.setColumWidthforHeader(headings);
    worksheet.columns = columns;
    const headerRow = worksheet.getRow(1);
    this.setHeaderTheme(headerRow);
    workbook.csv.writeBuffer().then((buffer: any) => {
      const blob = new Blob([buffer], {
        type: 'application/vnd.opencsvformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `${fileName}${EXCEL_EXTENSION}`);
    });
  }

  private setColumWidthforHeader(headings: any) {
    return headings.map(header => {
      return {
        header: header.toString(),
        width: header.length + 5,
      };
    });
  }

  private setHeaderTheme(headerRow: any) {
    return headerRow.eachCell(cell => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '7393B3' },
        bgColor: { argb: '' },
      };
      cell.font = {
        bold: true,
        color: { argb: 'FFFFFF' },
        size: 12,
      };
      cell.border = {
        top: { style: 'thick' },
        left: { style: 'thick' },
        bottom: { style: 'thick' },
        right: { style: 'thick' },
      };
      cell.alignment = { vertical: 'middle', horizontal: 'middle', shrinkToFit: false };
    });
  }
}
